import React, { useEffect, useRef, useState } from 'react';
import { Loader2, Paperclip, SendHorizonal } from 'lucide-react';

const Input = ({
  onSendMessage,
  isLoading,
  placeholder = 'Ask a learning question...',
  variant = 'default'
}) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 140)}px`;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmed = message.trim();
    if (!trimmed || isLoading) return;

    onSendMessage(trimmed);
    setMessage('');
    requestAnimationFrame(adjustTextareaHeight);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleInputChange = (event) => {
    setMessage(event.target.value);
    requestAnimationFrame(adjustTextareaHeight);
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, []);

  return (
    <div className={`lrbrain-input-container ${variant === 'hero' ? 'hero' : ''}`}>
      <form className="lrbrain-input-form" onSubmit={handleSubmit}>
        <div className="lrbrain-input-wrapper">
          <button
            type="button"
            className="lrbrain-attachment-button"
            title="Attach file (coming soon)"
            aria-label="Attach file"
          >
            <Paperclip size={20} />
          </button>
          <textarea
            ref={textareaRef}
            className="lrbrain-input"
            value={message}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            disabled={isLoading}
            rows={1}
          />
        </div>
        <button
          type="submit"
          className="lrbrain-send-button"
          disabled={!message.trim() || isLoading}
          title={isLoading ? 'Sending...' : 'Send message'}
          aria-label={isLoading ? 'Sending message' : 'Send message'}
        >
          {isLoading ? <Loader2 size={20} className="spin-icon" /> : <SendHorizonal size={20} />}
        </button>
      </form>
    </div>
  );
};

export default Input;
